export const jobs = {
      "Dolby Consultant": "Consultor Dolby",
      "First Assistant Sound Editor": "Primeiro Assistente de Edição de Som",
      "Music Director": "Diretor Musical",
      "Songs": "Músicas",
      "Sound Engineer": "Engenheiro de Som",
      "Orchestrator": "Orquestrador",
      "Music Supervisor": "Supervisor Musical",
      "ADR Editor": "Editor ADR",
      "Sound Effects": "Efeitos Sonoros",
      "Supervising Music Editor": "Editor Musical Supervisor",
      "Recording Supervision": "Supervisão de Gravação",
      "Additional Sound Re-Recording Mixer": "Mixer de Regravação de Som Adicional",
      "Apprentice Sound Editor": "Aprendiz de Editor de Som",
      "Sound Mixer": "Mixer de Som",
      "Additional Music Supervisor": "Supervisor Musical Adicional",
      "Conductor": "Condutor",
      "Playback Singer": "Cantor de Playback",
      "Supervising Dialogue Editor": "Editor de Diálogo Supervisor",
      "Other": "Outro",
      "Assistant Sound Editor": "Assistente de Edição de Som",
      "Foley Editor": "Editor de Foley",
      "Supervising Sound Editor": "Editor de Som Supervisor",
      "Sound Recordist": "Gravador de Som",
      "Sound Effects Designer": "Designer de Efeitos Sonoros",
      "Theme Song Performance": "Performance da Música Tema",
      "Sound Montage Associate": "Associado de Montagem de Som",
      "Assistant Music Supervisor": "Assistente de Supervisor Musical",
      "Sound Editor": "Editor de Som",
      "Sound Director": "Diretor de Som",
      "Additional Soundtrack": "Trilha Sonora Adicional",
      "Musician": "Músico",
      "Utility Sound": "Som de Utilidade",
      "Original Music Composer": "Compositor de Música Original",
      "Sound Designer": "Designer de Som",
      "Production Sound Mixer": "Mixer de Som de Produção",
      "Dialogue Editor": "Editor de Diálogo",
      "Additional Sound Re-Recordist": "Regravação de Som Adicional",
      "Music Programmer": "Programador Musical",
      "Supervising ADR Editor": "Editor ADR Supervisor",
      "Sound Re-Recording Mixer": "Mixer de Regravação de Som",
      "Boom Operator": "Operador de Boom",
      "Scoring Mixer": "Mixer de Trilha Sonora",
      "Foley": "Foley",
      "Vocal Coach": "Treinador Vocal",
      "ADR Supervisor": "Supervisor de ADR",
      "Music Editor": "Editor Musical",
      "Sound Effects Editor": "Editor de Efeitos Sonoros",
      "Music": "Música",
      "ADR & Dubbing": "ADR & Dublagem",
      "Music Score Producer": "Produtor de Trilha Sonora",
      "Supervising Sound Effects Editor": "Editor de Efeitos Sonoros Supervisor",
      "Sound": "Som",
      "ADR Recording Engineer": "Engenheiro de Gravação de ADR",
      "Assistant Sound Designer": "Assistente de Designer de Som",
      "ADR Engineer": "Engenheiro de ADR",
      "Audio Post Coordinator": "Coordenador de Pós-Produção de Áudio",
      "Sound Technical Supervisor": "Supervisor Técnico de Som",
      "ADR Recordist": "Gravador de ADR",
      "Loop Group Coordinator": "Coordenador de Grupo de Loop",
      "Foley Recordist": "Gravador de Foley",
      "Additional Production Sound Mixer": "Mixer de Som de Produção Adicional",
      "ADR Editor": "Editor de ADR",
      "Music Coordinator": "Coordenador Musical",
      "Sound Post Supervisor": "Supervisor de Pós-Produção de Som",
      "ADR Coordinator": "Coordenador de ADR",
      "Second Assistant Sound": "Segundo Assistente de Som",
      "Music Producer": "Produtor Musical",
      "Music Supervision Assistant": "Assistente de Supervisão Musical",
      "Sound Re-Recording Assistant": "Assistente de Regravação de Som",
      "Vocals": "Vocais",
      "Assistant Sound Engineer": "Assistente de Engenheiro de Som",
      "Foley Supervisor": "Supervisor de Foley",
      "Location Sound Mixer": "Mixer de Som de Localização",
      "Music Sound Design and Processing": "Design e Processamento de Som Musical",
      "Sound Post Production Coordinator": "Coordenador de Pós-Produção de Som",
      "ADR Mixer": "Mixer de ADR",
      "Digital Foley Artist": "Artista de Foley Digital",
      "Joint ADR Mixer": "Mixer de ADR Conjunto",
      "Main Title Theme Composer": "Compositor do Tema do Título Principal",
      "Music Co-Supervisor": "Co-Supervisor Musical",
      "Foley Mixer": "Mixer de Foley",
      "Location Sound Recordist": "Gravador de Som de Localização",
      "Assistant Foley Artist": "Assistente de Artista de Foley",
      "Assistant Dialogue Editor": "Assistente de Editor de Diálogo",
      "Keyboard Programmer": "Programador de Teclado",
      "Music Consultant": "Consultor Musical",
      "Sound Mix Technician": "Técnico de Mixagem de Som",
      "Location Sound Assistant": "Assistente de Som de Localização",
      "O.B. Sound": "Som O.B.",
      "Foley Artist": "Artista de Foley",
      "Foley Recording Engineer": "Engenheiro de Gravação de Foley",
      "Music Arranger": "Arranjador Musical",
      "Sound Assistant": "Assistente de Som",
      "ADR Post Producer": "Produtor de Pós-Produção de ADR",
      "Sound Supervisor": "Supervisor de Som",
      "Sculptor": "Escultor",
      "Assistant Set Dresser": "Assistente de Figurino de Cena",
      "Title Designer": "Designer de Título",
      "Additional Construction": "Construção Adicional",
      "Assistant Set Designer": "Assistente de Designer de Cena",
      "Shop Electric": "Eletricista de Oficina",
      "Additional Set Dresser": "Figurino de Cena Adicional",
      "On Set Key Props": "Props Chave no Set",
      "Set Supervisor": "Supervisor de Cena",
      "Storyboard Artist": "Artista de Storyboard",
      "Leadman": "Líder de Equipe",
      "First Assistant Property Master": "Primeiro Assistente de Mestre de Propriedades",
      "Head Designer": "Designer Chefe",
      "Paint Coordinator": "Coordenador de Pintura",
      "Set Propsman": "Props de Cena",
      "Standby Carpenter": "Carpinteiro de Reserva",
      "Title Illustration": "Ilustração de Título",
      "Production Design": "Design de Produção",
      "Construction Coordinator": "Coordenador de Construção",
      "Construction Foreman": "Mestre de Obras",
      "Lead Painter": "Pintor Chefe",
      "Painter": "Pintor",
      "Assistant Production Design": "Assistente de Design de Produção",
      "Daily Grip": "Grip Diário",
      "Helping Hand": "Ajuda",
      "Original Series Design": "Design de Série Original",
      "Set Dressing Buyer": "Comprador de Figurino de Cena",
      "Special Props": "Props Especiais",
      "Supervising Carpenter": "Carpinteiro Supervisor",
      "Textile Artist": "Artista Têxtil",
      "Property Master": "Mestre de Propriedades",
      "Draughtsman": "Desenhista",
      "Concept Artist": "Artista de Conceito",
      "Decorator": "Decorador",
      "Lead Set Dresser": "Figurino de Cena Principal",
      "Assistant Set Propsman": "Assistente de Props de Cena",
      "On Set Computer Graphics": "Gráficos de Computador no Set",
      "Opening Title Sequence": "Sequência de Abertura de Título",
      "Art Department Manager": "Gerente de Departamento de Arte",
      "Greensman": "Verdeiro",
      "First Assistant Art Direction": "Primeiro Assistente de Direção de Arte",
      "Graphic Designer": "Designer Gráfico",
      "Runner Art Department": "Corredor de Departamento de Arte",
      "Standby Art Director": "Diretor de Arte de Reserva",
      "Co-Art Director": "Co-Diretor de Arte",
      "Set Decorating Coordinator": "Coordenador de Decoração de Cena",
      "Storyboard Designer": "Designer de Storyboard",
      "Art Designer": "Designer de Arte",
      "Art Direction Intern": "Estagiário de Direção de Arte",
      "Property Graphic Designer": "Designer Gráfico de Propriedade",
      "Production Illustrator": "Ilustrador de Produção",
      "Property Builder": "Construtor de Propriedade",
      "Swing": "Swing",
      "Set Designer": "Designer de Cena",
      "Standby Painter": "Pintor de Reserva",
      "Gun Wrangler": "Coordenador de Armas",
      "Conceptual Illustrator": "Ilustrador Conceitual",
      "Assistant Director of Photography": "Assistente de Diretor de Fotografia",
      "Assistant Set Decoration Buyer": "Comprador Assistente de Decoração de Cena",
      "Construction Buyer": "Comprador de Construção",
      "Construction Grip": "Grip de Construção",
      "Petty Cash Buyer": "Comprador de Caixa Pequena",
      "Art Direction": "Direção de Arte",
      "Art Department Coordinator": "Coordenador de Departamento de Arte",
      "Assistant Property Master": "Assistente de Mestre de Propriedades",
      "Set Dresser": "Figurino de Cena",
      "Creative Director": "Diretor Criativo",
      "Conceptual Design": "Design Conceitual",
      "Set Decoration Buyer": "Comprador de Decoração de Cena",
      "Additional Construction Grip": "Grip Adicional de Construção",
      "Head Carpenter": "Carpinteiro Chefe",
      "Head Greensman": "Verdeiro Chefe",
      "Key Carpenter": "Carpinteiro Principal",
      "Props": "Props",
      "Set Painter": "Pintor de Cena",
      "Web Designer": "Designer de Web",
      "Set Decoration": "Decoração de Cena",
      "Art Department Assistant": "Assistente de Departamento de Arte",
      "Additional Storyboarding": "Storyboarding Adicional",
      "Assistant Set Decoration": "Assistente de Decoração de Cena",
      "Construction Manager": "Gerente de Construção",
      "Set Buyer": "Comprador de Cena",
      "Background Designer": "Designer de Cenários",
      "Location Scout": "Explorador de Localização",
      "Sign Painter": "Pintor de Placa",
      "Key Set Painter": "Pintor de Cena Principal",
      "Interior Designer": "Designer de Interiores",
      "Assistant Art Director": "Assistente de Diretor de Arte",
      "Supervising Art Director": "Diretor de Arte Supervisor",
      "Additional Key Construction Grip": "Grip Adicional de Construção Principal",
      "Art Department Trainee": "Estagiário de Departamento de Arte",
      "Assistant Decorator": "Assistente de Decorador",
      "Digital Storyboarding": "Storyboarding Digital",
      "Dressing Prop": "Figurino de Prop",
      "Head Decorator": "Decorador Chefe",
      "Key Construction Grip": "Grip Principal de Construção",
      "On Set Props": "Props no Set",
      "Storyboard Assistant": "Assistente de Storyboard",
      "Settings": "Cenários",
      "Other": "Outro",
      "Prop Designer": "Designer de Props",
      "Main Title Designer": "Designer de Título Principal",
      "Property Buyer": "Comprador de Propriedade",
      "Second Assistant Art Direction": "Segundo Assistente de Direção de Arte",
      "Assistant Director": "Assistente de Diretor",
      "Production Assistant": "Assistente de Produção",
      "Crew Member": "Membro da Equipe",
      "Location Manager": "Gerente de Localização",
      "Production Coordinator": "Coordenador de Produção",
      "Script Supervisor": "Supervisor de Roteiro",
      "Assistant Production Coordinator": "Assistente de Coordenador de Produção",
      "Production Assistant – Office": "Assistente de Produção – Escritório",
      "Unit Production Manager": "Gerente de Produção de Unidade",
      "Set Production Assistant": "Assistente de Produção de Set",
      "Production Accountant": "Contador de Produção",
      "Casting Assistant": "Assistente de Elenco",
      "Camera Assistant": "Assistente de Câmera",
      "Production Design Assistant": "Assistente de Design de Produção",
      "Grip": "Grip",
      "Electrician": "Eletricista",
      "Best Boy": "Melhor Boy",
      "Gaffer": "Gaffer",
      "Production Sound Assistant": "Assistente de Som de Produção",
      "Location Assistant": "Assistente de Localização",
      "Transport Coordinator": "Coordenador de Transporte",
      "Transportation Captain": "Capitão de Transporte",
      "Unit Publicist": "Publicitário de Unidade",
      "Assistant Camera": "Assistente de Câmera",
      "Assistant Editor": "Assistente de Edição",
      "Production Runner": "Corredor de Produção",
      "Production Sound Mixer": "Mixer de Som de Produção",
      "Script Reader": "Leitor de Roteiro",
      "Unit Coordinator": "Coordenador de Unidade",
      "Set Runner": "Corredor de Set",
      "Assistant Location Manager": "Assistente de Gerente de Localização",
      "Set Costumer": "Figurinista de Set",
      "Casting Director Assistant": "Assistente de Diretor de Elenco",
      "Costume Assistant": "Assistente de Figurino",
      "Production Runner – Office": "Corredor de Produção – Escritório",
      "Key Grip": "Grip Principal",
      "Director’s Assistant": "Assistente de Diretor",
      "Sound Assistant": "Assistente de Som",
      "Camera Operator": "Operador de Câmera",
      "Grip and Electric": "Grip e Elétrico",
      "Special Effects Assistant": "Assistente de Efeitos Especiais",
      "Makeup Assistant": "Assistente de Maquiagem",
      "Second Assistant Director": "Segundo Assistente de Diretor",
      "Art Assistant": "Assistente de Arte",
      "Production Assistant – Set": "Assistente de Produção – Set",
      "Unit Assistant": "Assistente de Unidade",
      "Sound Editor": "Editor de Som",
      "Second Assistant Camera": "Segundo Assistente de Câmera",
      "Sound Recordist": "Gravador de Som",
      "Assistant Production Designer": "Assistente de Designer de Produção",
      "Assistant Script Supervisor": "Assistente de Supervisor de Roteiro",
      "Sound Mixer": "Mixer de Som",
      "Unit Publicity Assistant": "Assistente de Publicidade de Unidade",
      "Location Scout Assistant": "Assistente de Explorador de Localização",
      "Costume Designer Assistant": "Assistente de Designer de Figurino",
      "Transportation Assistant": "Assistente de Transporte",
      "Stage Manager": "Gerente de Palco",
      "Visual Effects Assistant": "Assistente de Efeitos Visuais",
      "Property Assistant": "Assistente de Propriedade",
      "Production Crew": "Equipe de Produção",
      "Camera Loader": "Carregador de Câmera",
      "Makeup Artist Assistant": "Assistente de Artista de Maquiagem",
      "Sound Editor Assistant": "Assistente de Editor de Som",
      "Grip Assistant": "Assistente de Grip",
      "Digital Intermediate Assistant": "Assistente de Digital Intermediate",
      "First Assistant Picture Editor": "Primeiro Assistente de Edição de Imagem",
      "Lead Editor": "Editor Principal",
      "Project Manager": "Gerente de Projeto",
      "Negative Cutter": "Cortador de Negativo",
      "3D Digital Colorist": "Colorista Digital 3D",
      "Additional Editing": "Edição Adicional",
      "Color Timer": "Cronometrista de Cor",
      "Assistant Picture Editor": "Assistente de Edição de Imagem",
      "Dailies Technician": "Técnico de Dailies",
      "Digital Intermediate": "Digital Intermediate",
      "Co-Editor": "Co-Editor",
      "Additional Editor": "Editor Adicional",
      "Dailies Manager": "Gerente de Dailies",
      "Editor": "Editor",
      "First Assistant Editor": "Primeiro Assistente de Edição",
      "Editorial Production Assistant": "Assistente de Produção Editorial",
      "Editorial Manager": "Gerente Editorial",
      "Additional Editorial Assistant": "Assistente Editorial Adicional",
      "Assistant Editor": "Assistente de Edição",
      "Color Grading": "Correção de Cor",
      "Dailies Operator": "Operador de Dailies",
      "Digital Intermediate Colorist": "Colorista Digital Intermediate",
      "Digital Intermediate Producer": "Produtor Digital Intermediate",
      "EPK Editor": "Editor de EPK",
      "Senior Colorist": "Colorista Sênior",
      "Supervising Film Editor": "Editor Supervisor de Filme",
      "Digital Conform Editor": "Editor de Conformação Digital",
      "Editorial Consultant": "Consultor Editorial",
      "Archival Footage Research": "Pesquisa de Imagens Arquivadas",
      "Digital Color Timer": "Cronometrista Digital de Cor",
      "Digital Intermediate Data Wrangler": "Manipulador de Dados Digital Intermediate",
      "Senior Digital Intermediate Colorist": "Colorista Sênior de Digital Intermediate",
      "Associate Editor": "Editor Associado",
      "Online Editor": "Editor Online",
      "Archival Footage Coordinator": "Coordenador de Imagens Arquivadas",
      "Colorist": "Colorista",
      "Consulting Editor": "Editor Consultor",
      "Stereoscopic Editor": "Editor Estereoscópico",
      "Supervising Editor": "Editor Supervisor",
      "Other": "Outro",
      "Atmos Editor": "Editor de Atmos",
      "Color Assistant": "Assistente de Cor",
      "Editorial Services": "Serviços Editoriais",
      "Additional Colorist": "Colorista Adicional",
      "Digital Intermediate Editor": "Editor Digital Intermediate",
      "Editorial Coordinator": "Coordenador Editorial",
      "3D Editor": "Editor 3D",
      "Digital Colorist": "Colorista Digital",
      "Scenario Writer": "Roteirista de Cenário",
      "Story": "História",
      "Co-Writer": "Co-Roteirista",
      "Series Composition": "Composição de Série",
      "Original Story": "História Original",
      "Screenplay": "Roteiro",
      "Author": "Autor",
      "Adaptation": "Adaptação",
      "Writer": "Escritor",
      "Book": "Livro",
      "Other": "Outro",
      "Characters": "Personagens",
      "Theatre Play": "Peça Teatral",
      "Musical": "Musical",
      "Screenstory": "História Cinematográfica",
      "Teleplay": "Roteiro para Televisão",
      "Storyboard": "Roteiro Gráfico",
      "Creative Producer": "Produtor Criativo",
      "Script Consultant": "Consultor de Roteiro",
      "Idea": "Ideia",
      "Opera": "Ópera",
      "Comic Book": "História em Quadrinhos",
      "Script Editor": "Editor de Roteiro",
      "Novel": "Romance",
      "Dialogue": "Diálogo",
      "Story Editor": "Editor de História",
      "Short Story": "Conto",
      "Story Coordinator": "Coordenador de História",
      "Story Consultant": "Consultor de História",
      "Story Developer": "Desenvolvedor de História",
      "Junior Story Editor": "Editor de História Júnior",
      "Story Artist": "Artista de História",
      "Staff Writer": "Roteirista da Equipe",
      "Original Film Writer": "Roteirista de Filme Original",
      "Story Supervisor": "Supervisor de História",
      "Writers' Assistant": "Assistente de Roteiristas",
      "Graphic Novel": "Romance Gráfico",
      "Writers' Production": "Produção de Roteiristas",
      "Senior Story Editor": "Editor de História Sênior",
      "Original Concept": "Conceito Original",
      "Original Series Creator": "Criador de Série Original",
      "Executive Story Editor": "Editor Executivo de História",
      "Head of Story": "Chefe de História",
      "Lyricist": "Letrista",
      "Story Manager": "Gerente de História",
      "Other": "Outro",
      "First Assistant Director Trainee": "Estagiário de Primeiro Assistente de Direção",
      "Insert Unit First Assistant Director": "Primeiro Assistente de Direção da Unidade de Inserção",
      "First Assistant Director": "Primeiro Assistente de Direção",
      "Layout": "Layout",
      "Continuity": "Continuidade",
      "Assistant Director Trainee": "Estagiário de Diretor Assistente",
      "Second Assistant Director Trainee": "Estagiário de Segundo Assistente de Direção",
      "Second Unit Director": "Diretor de Segunda Unidade",
      "Second Unit First Assistant Director": "Primeiro Assistente de Direção da Segunda Unidade",
      "Additional Third Assistant Director": "Terceiro Assistente de Direção Adicional",
      "First Assistant Director (Prep)": "Primeiro Assistente de Direção (Preparação)",
      "Co-Director": "Co-Diretor",
      "Script Coordinator": "Coordenador de Roteiro",
      "Assistant Director": "Diretor Assistente",
      "Crowd Assistant Director": "Diretor Assistente de Multidão",
      "Second Second Assistant Director": "Segundo Segundo Assistente de Direção",
      "Series Director": "Diretor de Série",
      "Director": "Diretor",
      "Script Supervisor": "Supervisor de Roteiro",
      "Special Guest Director": "Diretor Convidado Especial",
      "Action Director": "Diretor de Ação",
      "Second Assistant Director": "Segundo Assistente de Direção",
      "Third Assistant Director": "Terceiro Assistente de Direção",
      "Field Director": "Diretor de Campo",
      "Insert Unit Director": "Diretor da Unidade de Inserção",
      "Stage Director": "Diretor de Palco",
      "Additional Second Assistant Director": "Segundo Assistente de Direção Adicional",
      "Makeup Designer": "Designer de Maquiagem",
      "Assistant Makeup Artist": "Assistente de Maquiador",
      "Contact Lens Designer": "Designer de Lentes de Contato",
      "Daily Wardrobe": "Figurino Diário",
      "Hairstylist": "Cabeleireiro",
      "Makeup Department Head": "Chefe de Departamento de Maquiagem",
      "Assistant Costume Designer": "Assistente de Designer de Figurino",
      "Ager/Dyer": "Tingidor/Colorista",
      "Hair Supervisor": "Supervisor de Cabelos",
      "Key Costumer": "Figurinista Principal",
      "Key Makeup Artist": "Maquiador Principal",
      "Makeup Effects Designer": "Designer de Efeitos de Maquiagem",
      "Prosthetic Designer": "Designer de Prótese",
      "Tattoo Designer": "Designer de Tatuagem",
      "Contact Lens Painter": "Pintor de Lentes de Contato",
      "Costume Standby": "Figurinista de Plantão",
      "Costume Illustrator": "Ilustrador de Figurino",
      "Makeup & Hair": "Maquiagem & Cabelos",
      "Prosthetics Sculptor": "Escultor de Prótese",
      "Costume Design": "Design de Figurino",
      "Makeup Artist": "Maquiador",
      "Additional Wardrobe Assistant": "Assistente Adicional de Figurino",
      "Assistant Hairdresser": "Assistente de Cabeleireiro",
      "Extras Dresser": "Figurinista de Figurantes",
      "First Assistant Makeup Artist": "Primeiro Assistente de Maquiador",
      "Wardrobe Master": "Mestre de Figurino",
      "Shoe Design": "Design de Sapatos",
      "Prosthetic Makeup Artist": "Maquiador de Prótese",
      "Costumer": "Figurinista",
      "Key Dresser": "Figurinista Principal",
      "Key Hairdresser": "Cabeleireiro Principal",
      "Wigmaker": "Perucista",
      "Hair Department Head": "Chefe de Departamento de Cabelos",
      "Costume Mistress": "Mestre de Figurino",
      "First Assistant Hairstylist": "Primeiro Assistente de Cabeleireiro",
      "Wardrobe Assistant": "Assistente de Figurino",
      "Wardrobe Intern": "Estagiário de Figurino",
      "Costume Supervisor": "Supervisor de Figurino",
      "Other": "Outro",
      "Co-Costume Designer": "Co-Designer de Figurino",
      "Additional Hairstylist": "Cabeleireiro Adicional",
      "Contact Lens Technician": "Técnico de Lentes de Contato",
      "Dresser": "Figurinista",
      "Extras Makeup Artist": "Maquiador de Figurantes",
      "Makeup & Hair Assistant": "Assistente de Maquiagem & Cabelos",
      "Prosthetics Painter": "Pintor de Prótese",
      "Facial Setup Artist": "Artista de Configuração Facial",
      "Costume Coordinator": "Coordenador de Figurino",
      "Hair Assistant": "Assistente de Cabelos",
      "On Set Dresser": "Figurinista de Set",
      "Truck Costumer": "Figurinista de Caminhão",
      "Wardrobe Coordinator": "Coordenador de Figurino",
      "Set Dressing Supervisor": "Supervisor de Decoração de Set",
      "Costume Consultant": "Consultor de Figurino",
      "Key Set Costumer": "Figurinista Principal de Set",
      "Makeup Supervisor": "Supervisor de Maquiagem",
      "Tailor": "Alfaiate",
      "Hairdresser": "Cabeleireiro",
      "Set Costumer": "Figurinista de Set",
      "Seamstress": "Costureira",
      "Costume Assistant": "Assistente de Figurino",
      "Costume Set Supervisor": "Supervisor de Figurino de Set",
      "Prosthetics": "Próteses",
      "Set Dressing Artist": "Artista de Decoração de Set",
      "Set Dressing Manager": "Gerente de Decoração de Set",
      "Set Dressing Production Assistant": "Assistente de Produção de Decoração de Set",
      "Wig Designer": "Designer de Peruca",
      "Daily Makeup & Hair": "Maquiagem & Cabelos Diários",
      "Principal Costumer": "Figurinista Principal",
      "Hair Setup": "Configuração de Cabelos",
      "Hair Designer": "Designer de Cabelos",
      "Key Hair Stylist": "Cabeleireiro Principal",
      "Wardrobe Supervisor": "Supervisor de Figurino",
      "Makeup Trainee": "Estagiário de Maquiagem",
      "Special Effects Makeup Artist": "Maquiador de Efeitos Especiais",
      "Truck Supervisor": "Supervisor de Caminhão",
      "Prosthetic Supervisor": "Supervisor de Prótese",
      "Special Effects Key Makeup Artist": "Maquiador Principal de Efeitos Especiais",
      "Wardrobe Designer": "Designer de Figurino",
      "Assistant Hairstylist": "Assistente de Cabeleireiro",
      "Costume Designer": "Designer de Figurino",
      "Lead Costumer": "Figurinista Principal",
      "Wardrobe Specialized Technician": "Técnico Especializado de Figurino",
      "Location Manager": "Gerente de Locação",
      "Other": "Outro",
      "Executive Consultant": "Consultor Executivo",
      "Co-Producer": "Co-Produtor",
      "Additional Casting": "Casting Adicional",
      "Executive Producer": "Produtor Executivo",
      "Publicist": "Publicitário",
      "Accounting Supervisor": "Supervisor de Contabilidade",
      "Line Producer": "Produtor de Linha",
      "Development Manager": "Gerente de Desenvolvimento",
      "Administration": "Administração",
      "Executive In Charge Of Post Production": "Executivo Responsável pela Pós-Produção",
      "Unit Manager": "Gerente de Unidade",
      "Assistant Production Manager": "Assistente de Gerente de Produção",
      "Casting Assistant": "Assistente de Casting",
      "Casting Consultant": "Consultor de Casting",
      "Accounting Trainee": "Estagiário de Contabilidade",
      "Senior Executive Consultant": "Consultor Executivo Sênior",
      "Production Accountant": "Contador de Produção",
      "Finance": "Finanças",
      "Researcher": "Pesquisador",
      "Supervising Producer": "Produtor Supervisor",
      "ADR Voice Casting": "Casting de Voz ADR",
      "Coordinating Producer": "Produtor Coordenador",
      "Producer": "Produtor",
      "Unit Production Manager": "Gerente de Produção de Unidade",
      "Production Director": "Diretor de Produção",
      "Executive In Charge Of Production": "Executivo Responsável pela Produção",
      "Associate Producer": "Produtor Associado",
      "Accounting Clerk Assistant": "Assistente de Contabilidade",
      "Assistant Production Coordinator": "Assistente de Coordenador de Produção",
      "Additional Production Assistant": "Assistente de Produção Adicional",
      "Assistant Extras Casting": "Assistente de Casting de Figurantes",
      "Consulting Producer": "Produtor Consultor",
      "Additional Post-Production Supervisor": "Supervisor Adicional de Pós-Produção",
      "Production Manager": "Gerente de Produção",
      "Character Technical Supervisor": "Supervisor Técnico de Personagens",
      "Co-Executive Producer": "Co-Produtor Executivo",
      "Accountant": "Contador",
      "Casting": "Casting",
      "Casting Associate": "Associado de Casting",
      "Production Coordinator": "Coordenador de Produção",
      "Local Casting": "Casting Local",
      "Art Department Production Assistant": "Assistente de Produção do Departamento de Arte",
      "Production Office Coordinator": "Coordenador de Escritório de Produção",
      "Script Researcher": "Pesquisador de Roteiro",
      "Assistant Accountant": "Assistente de Contador",
      "Production Supervisor": "Supervisor de Produção",
      "Background Casting Director": "Diretor de Casting de Figurantes",
      "Executive Assistant": "Assistente Executivo",
      "Extras Casting": "Casting de Figurantes",
      "Key Set Production Assistant": "Assistente de Produção de Set Principal",
      "Location Production Assistant": "Assistente de Produção de Locação",
      "Production Trainee": "Estagiário de Produção",
      "Extras Casting Assistant": "Assistente de Casting de Figurantes",
      "Head of Research": "Chefe de Pesquisa",
      "Trainee Production Coordinator": "Estagiário de Coordenador de Produção",
      "Back-up Truck Production Assistant": "Assistente de Produção de Caminhão de Reserva",
      "General Manager": "Gerente Geral",
      "Production Driver": "Motorista de Produção",
      "Casting Producer": "Produtor de Casting",
      "Casting Researcher": "Pesquisador de Casting",
      "Location Assistant": "Assistente de Locação",
      "Production Assistant": "Assistente de Produção",
      "Assistant Location Manager": "Assistente de Gerente de Locação",
      "Broadcast Producer": "Produtor de Transmissão",
      "Casting Coordinator": "Coordenador de Casting",
      "Insert Unit Location Manager": "Gerente de Locação da Unidade de Inserção",
      "Payroll Accountant": "Contador de Folha de Pagamento",
      "Producer's Assistant": "Assistente do Produtor",
      "Unit Swing": "Swing de Unidade",
      "Assistant Unit Manager": "Assistente de Gerente de Unidade",
      "Business Affairs Coordinator": "Coordenador de Assuntos Comerciais",
      "Data Management Technician": "Técnico de Gerenciamento de Dados",
      "Finishing Producer": "Produtor de Finalização",
      "Head of Programming": "Chefe de Programação",
      "Human Resources": "Recursos Humanos",
      "Key Production Assistant": "Assistente de Produção Principal",
      "Location Coordinator": "Coordenador de Locação",
      "Post Production Producer": "Produtor de Pós-Produção",
      "Street Casting": "Casting de Rua",
      "Casting Director": "Diretor de Casting",
      "Controller": "Controlador",
      "Grip Production Assistant": "Assistente de Produção de Grip",
      "Key Art Production Assistant": "Assistente de Produção de Arte Principal",
      "Production Consultant": "Consultor de Produção",
      "Travel Coordinator": "Coordenador de Viagens",
      "Delegated Producer": "Produtor Delegado",
      "Extras Casting Coordinator": "Coordenador de Casting de Figurantes",
      "First Assistant Production Coordinator": "Primeiro Assistente de Coordenador de Produção",
      "Post Producer": "Produtor de Pós-Produção",
      "Attorney": "Advogado",
      "Contract Manager": "Gerente de Contrato",
      "Executive Co-Producer": "Co-Produtor Executivo",
      "Location Casting": "Casting de Locação",
      "Production Executive": "Executivo de Produção",
      "Production Runner": "Corredor de Produção",
      "Production Secretary": "Secretário de Produção",
      "Research Assistant": "Assistente de Pesquisa",
      "Second Assistant Unit Manager": "Segundo Assistente de Gerente de Unidade",
      "Post Production Coordinator": "Coordenador de Pós-Produção",
      "Truck Production Assistant": "Assistente de Produção de Caminhão",
      "Back-up Set Production Assistant": "Assistente de Produção de Set de Reserva",
      "Development Producer": "Produtor de Desenvolvimento",
      "Head of Production": "Chefe de Produção",
      "Key Grip Production Assistant": "Assistente de Produção de Grip Principal",
      "Locale Casting Director": "Diretor de Casting Local",
      "Second Assistant Accountant": "Segundo Assistente de Contador",
      "Musical Casting": "Casting Musical",
      "Post Production Accountant": "Contador de Pós-Produção",
      "First Assistant Accountant": "Primeiro Assistente de Contador",
      "Original Casting": "Casting Original",
      "Production Designer": "Designer de Produção",
      "Second Unit Location Manager": "Gerente de Locação da Segunda Unidade",
      "Consulting Accountant": "Contador Consultor",
      "Post Coordinator": "Coordenador de Pós-Produção",
      "Post Production Technical Engineer": "Engenheiro Técnico de Pós-Produção",
      "Director of Operations": "Diretor de Operações",
      "Executive Producer's Assistant": "Assistente do Produtor Executivo",
      "Feature Finishing Producer": "Produtor de Finalização de Longa-Metragem",
      "Key Accountant": "Contador Principal",
      "Second Assistant Production Coordinator": "Segundo Assistente de Coordenador de Produção",
      "Cameo": "Participação Especial",
      "Actor": "Ator",
      "Special Guest": "Convidado Especial",
      "Voice": "Voz",
      "Stunt Double": "Dublê de Ação",
      "CG Painter": "Pintor de CG",
      "24 Frame Playback": "Reprodução de 24 Quadros",
      "I/O Manager": "Gerente de I/O",
      "Mechanical Designer": "Designer Mecânico",
      "Creature Technical Director": "Diretor Técnico de Criaturas",
      "Visual Effects": "Efeitos Visuais",
      "Chief Technician / Stop-Motion Expert": "Técnico Chefe / Especialista em Stop-Motion",
      "Creature Design": "Design de Criaturas",
      "I/O Supervisor": "Supervisor de I/O",
      "Visual Effects Designer": "Designer de Efeitos Visuais",
      "Visual Development": "Desenvolvimento Visual",
      "Animation Manager": "Gerente de Animação",
      "Fix Animator": "Animador de Correção",
      "Lead Character Designer": "Designer de Personagens Principal",
      "Opening/Ending Animation": "Animação de Abertura/Encerramento",
      "VFX Supervisor": "Supervisor de VFX",
      "Cloth Setup": "Configuração de Tecidos",
      "Visual Effects Producer": "Produtor de Efeitos Visuais",
      "VFX Production Coordinator": "Coordenador de Produção de VFX",
      "2D Supervisor": "Supervisor de 2D",
      "Character Designer": "Designer de Personagens",
      "Pyrotechnic Supervisor": "Supervisor de Pirotecnia",
      "3D Generalist": "Generalista 3D",
      "Digital Effects Producer": "Produtor de Efeitos Digitais",
      "Stereoscopic Coordinator": "Coordenador Estereoscópico",
      "Shading": "Sombreamento",
      "3D Director": "Diretor de 3D",
      "Digital Compositor": "Compositor Digital",
      "3D Modeller": "Modelador 3D",
      "Character Modelling Supervisor": "Supervisor de Modelagem de Personagens",
      "Animation Fix Coordinator": "Coordenador de Correção de Animação",
      "Color Designer": "Designer de Cor",
      "Battle Motion Coordinator": "Coordenador de Movimento de Batalha",
      "Animation Supervisor": "Supervisor de Animação",
      "Matchmove Supervisor": "Supervisor de Matchmove",
      "Animation Department Coordinator": "Coordenador de Departamento de Animação",
      "Simulation & Effects Artist": "Artista de Simulação & Efeitos",
      "3D Artist": "Artista 3D",
      "Lead Animator": "Animador Principal",
      "Pre-Visualization Supervisor": "Supervisor de Pré-Visualização",
      "Modeling": "Modelagem",
      "VFX Artist": "Artista de VFX",
      "Imaging Science": "Ciência de Imagem",
      "Special Effects Supervisor": "Supervisor de Efeitos Especiais",
      "CGI Director": "Diretor de CGI",
      "CG Engineer": "Engenheiro de CG",
      "3D Coordinator": "Coordenador de 3D",
      "3D Sequence Supervisor": "Supervisor de Sequência 3D",
      "CG Animator": "Animador de CG",
      "Key Animation": "Animação Chave",
      "VFX Director of Photography": "Diretor de Fotografia de VFX",
      "Visual Effects Coordinator": "Coordenador de Efeitos Visuais",
      "Visual Effects Technical Director": "Diretor Técnico de Efeitos Visuais",
      "Visual Effects Supervisor": "Supervisor de Efeitos Visuais",
      "Additional Effects Development": "Desenvolvimento Adicional de Efeitos",
      "Simulation & Effects Production Assistant": "Assistente de Produção de Simulação & Efeitos",
      "3D Supervisor": "Supervisor de 3D",
      "2D Artist": "Artista 2D",
      "Roto Supervisor": "Supervisor de Rotoscopia",
      "Animation": "Animação",
      "Animation Director": "Diretor de Animação",
      "3D Animator": "Animador 3D",
      "3D Tracking Layout": "Layout de Rastreamento 3D",
      "Animation Production Assistant": "Assistente de Produção de Animação",
      "Mechanical & Creature Designer": "Designer Mecânico & de Criaturas",
      "VFX Editor": "Editor de VFX",
      "VFX Lighting Artist": "Artista de Iluminação de VFX",
      "Visual Effects Compositor": "Compositor de Efeitos Visuais",
      "Visual Effects Lineup": "Escala de Efeitos Visuais",
      "Lead Creature Designer": "Designer Principal de Criaturas",
      "Pipeline Technical Director": "Diretor Técnico de Pipeline",
      "Photo Retouching": "Retoque de Fotografia",
      "Senior Generalist": "Generalista Sênior",
      "Visual Effects Assistant Editor": "Assistente de Editor de Efeitos Visuais",
      "Creature Effects Technical Director": "Diretor Técnico de Efeitos de Criaturas",
      "Visual Effects Director": "Diretor de Efeitos Visuais",
      "Modelling Supervisor": "Supervisor de Modelagem",
      "Rotoscoping Artist": "Artista de Rotoscopia",
      "Visual Effects Production Assistant": "Assistente de Produção de Efeitos Visuais",
      "Additional Visual Effects": "Efeitos Visuais Adicionais",
      "2D Sequence Supervisor": "Supervisor de Sequência 2D",
      "Compositing Artist": "Artista de Composição",
      "Director of Previsualization": "Diretor de Pré-Visualização",
      "Generalist": "Generalista",
      "Senior Modeller": "Modelador Sênior",
      "Stereoscopic Supervisor": "Supervisor Estereoscópico",
      "Animation Coordinator": "Coordenador de Animação",
      "Compositing Supervisor": "Supervisor de Composição",
      "Senior Animator": "Animador Sênior",
      "Pre-Visualization Coordinator": "Coordenador de Pré-Visualização",
      "Supervising Animation Director": "Diretor de Animação Supervisor",
      "Smoke Artist": "Artista de Fumaça",
      "Compositing Lead": "Líder de Composição",
      "Cyber Scanning Supervisor": "Supervisor de Digitalização Cibernética",
      "Layout Supervisor": "Supervisor de Layout",
      "Matte Painter": "Pintor Matte",
      "Visual Effects Production Manager": "Gerente de Produção de Efeitos Visuais",
      "Head of Animation": "Chefe de Animação",
      "Digital Film Recording": "Gravação de Filme Digital",
      "Effects Supervisor": "Supervisor de Efeitos",
      "Animation Technical Director": "Diretor Técnico de Animação",
      "CG Artist": "Artista de CG",
      "Senior Visual Effects Supervisor": "Supervisor Sênior de Efeitos Visuais",
      "Visual Effects Camera": "Câmera de Efeitos Visuais",
      "Stereoscopic Technical Director": "Diretor Técnico Estereoscópico",
      "Lighting Artist": "Artista de Iluminação",
      "Lighting Production Assistant": "Assistente de Produção de Iluminação",
      "Chief Lighting Technician": "Técnico Chefe de Iluminação",
      "Assistant Electrician": "Eletricista Assistente",
      "Lighting Manager": "Gerente de Iluminação",
      "Electrician": "Eletricista",
      "Other": "Outro",
      "Master Lighting Artist": "Artista Mestre de Iluminação",
      "Lighting Programmer": "Programador de Iluminação",
      "Gaffer": "Chefe de Iluminação",
      "Rigging Gaffer": "Gaffer de Rigging",
      "Rigging Grip": "Grip de Rigging",
      "Underwater Gaffer": "Gaffer Subaquático",
      "Assistant Chief Lighting Technician": "Assistente do Técnico Chefe de Iluminação",
      "Assistant Gaffer": "Assistente de Gaffer",
      "O.B. Lighting": "Iluminação O.B.",
      "Lighting Technician": "Técnico de Iluminação",
      "Key Rigging Grip": "Grip Principal de Rigging",
      "Lighting Design": "Design de Iluminação",
      "Best Boy Lighting Technician": "Melhor Eletricista de Iluminação",
      "Additional Gaffer": "Gaffer Adicional",
      "Genetator Operator": "Operador de Gerador",
      "Best Boy Electric": "Melhor Eletricista",
      "Lighting Coordinator": "Coordenador de Iluminação",
      "Daily Electrics": "Eletricistas Diários",
      "Rigging Supervisor": "Supervisor de Rigging",
      "Additional Lighting Technician": "Técnico de Iluminação Adicional",
      "Lighting Supervisor": "Supervisor de Iluminação",
      "Best Boy Electrician": "Melhor Eletricista Eletricista",
      "Directing Lighting Artist": "Artista de Iluminação Diretor",
      "Lighting Director": "Diretor de Iluminação",
      "Standby Rigger": "Rigger de Reserva",
      "Assistant Grip": "Assistente de Grip",
      "Data Wrangler": "Gerenciador de Dados",
      "First Assistant \"B\" Camera": "Primeiro Assistente de Câmera \"B\"",
      "Underwater Epk Photographer": "Fotógrafo Subaquático de Epk",
      "Video Report": "Relatório de Vídeo",
      "Aerial Camera": "Câmera Aérea",
      "Underwater Director of Photography": "Diretor de Fotografia Subaquática",
      "Best Boy Grip": "Melhor Grip",
      "BTS Videographer": "Videomaker de BTS",
      "Second Assistant \"B\" Camera": "Segundo Assistente de Câmera \"B\"",
      "\"D\" Camera Operator": "Operador de Câmera \"D\"",
      "Drone Pilot": "Piloto de Drone",
      "Second Assistant \"D\" Camera": "Segundo Assistente de Câmera \"D\"",
      "Second Company Grip": "Grip de Segunda Companhia",
      "Third Assistant \"B\" Camera": "Terceiro Assistente de Câmera \"B\"",
      "First Assistant Camera": "Primeiro Assistente de Câmera",
      "Aerial Camera Technician": "Técnico de Câmera Aérea",
      "Key Grip": "Grip Principal",
      "Additional Director of Photography": "Diretor de Fotografia Adicional",
      "Additional Underwater Photography": "Fotografia Subaquática Adicional",
      "Clapper Loader": "Carregador de Clapper",
      "First Company Grip": "Grip de Primeira Companhia",
      "Second Assistant \"C\" Camera": "Segundo Assistente de Câmera \"C\"",
      "Additional Photography": "Fotografia Adicional",
      "Assistant Camera": "Assistente de Câmera",
      "Camera Production Assistant": "Assistente de Produção de Câmera",
      "Digital Imaging Technician": "Técnico de Imagem Digital",
      "Third Assistant \"C\" Camera": "Terceiro Assistente de Câmera \"C\"",
      "Third Assistant Camera": "Terceiro Assistente de Câmera",
      "Underwater Stills Photographer": "Fotógrafo Subaquático de Imagens Fixas",
      "Camera Intern": "Estagiário de Câmera",
      "Second Unit Director of Photography": "Diretor de Fotografia da Segunda Unidade",
      "Camera Department Production Assistant": "Assistente de Produção do Departamento de Câmera",
      "Camera Supervisor": "Supervisor de Câmera",
      "Additional Camera": "Câmera Adicional",
      "Additional First Assistant Camera": "Primeiro Assistente de Câmera Adicional",
      "Additional Second Assistant Camera": "Segundo Assistente de Câmera Adicional",
      "Set Photographer": "Fotógrafo de Set",
      "Still Photographer": "Fotógrafo de Imagens Fixas",
      "\"B\" Camera Operator": "Operador de Câmera \"B\"",
      "Camera Car": "Câmera em Carro",
      "Jimmy Jib Operator": "Operador de Jimmy Jib",
      "Aerial Director of Photography": "Diretor de Fotografia Aérea",
      "Dolly Grip": "Grip de Dolly",
      "Epk Producer": "Produtor de Epk",
      "Focus Puller": "Focador",
      "Head of Layout": "Chefe de Layout",
      "Second Assistant \"A\" Camera": "Segundo Assistente de Câmera \"A\"",
      "Underwater Camera": "Câmera Subaquática",
      "Camera Technician": "Técnico de Câmera",
      "Russian Arm Operator": "Operador de Braço Russo",
      "Phantom Operator": "Operador de Phantom",
      "Red Technician": "Técnico de Red",
      "Helicopter Camera": "Câmera de Helicóptero",
      "BTS Photographer": "Fotógrafo de BTS",
      "Camera Trainee": "Estagiário de Câmera",
      "Epk Director": "Diretor de Epk",
      "Libra Head Technician": "Técnico Chefe de Libra Head",
      "Third Assistant \"D\" Camera": "Terceiro Assistente de Câmera \"D\"",
      "Grip": "Grip",
      "\"C\" Camera Operator": "Operador de Câmera \"C\"",
      "BTS Footage": "Filmagem de BTS",
      "Camera Truck": "Caminhão de Câmera",
      "First Assistant \"C\" Camera": "Primeiro Assistente de Câmera \"C\"",
      "Second Assistant Camera": "Segundo Assistente de Câmera",
      "Additional Still Photographer": "Fotógrafo Adicional de Imagens Fixas",
      "Epk Camera Operator": "Operador de Câmera Epk",
      "\"A\" Camera Operator": "Operador de Câmera \"A\"",
      "Additional Grip": "Grip Adicional",
      "Additional Key Grip": "Grip Principal Adicional",
      "Additional Set Photographer": "Fotógrafo de Set Adicional",
      "Drone Cinematographer": "Cinegrafista de Drone",
      "Steadicam Operator": "Operador de Steadicam",
      "Ultimate Arm Operator": "Operador de Ultimate Arm",
      "First Assistant \"A\" Camera": "Primeiro Assistente de Câmera \"A\"",
      "First Assistant \"D\" Camera": "Primeiro Assistente de Câmera \"D\"",
      "Third Assistant \"A\" Camera": "Terceiro Assistente de Câmera \"A\"",
      "Videojournalist": "Videomaker",
      "Director of Photography": "Diretor de Fotografia",
      "Camera Operator": "Operador de Câmera",
      "Camera Department Manager": "Gerente de Departamento de Câmera",
      "Other": "Outro",
      "Camera Loader": "Carregador de Câmera"
    };

export const departments = {
  "Sound": "Som",
  "Art": "Arte",
  "Crew": "Equipe",
  "Editing": "Edição",
  "Writing": "Roteiro",
  "Directing": "Direção",
  "Costume & Make-Up": "Figurino & Maquiagem",
  "Production": "Produção",
  "Actors": "Atores",
  "Visual Effects": "Efeitos Visuais",
  "Lighting": "Iluminação",
  "Camera": "Câmera",
};